import classNames from 'classnames'
import React from 'react'
import { Helmet } from 'react-helmet'
import { UI_ELEMENTS } from '../../store/ui/ui.constants'
import { selectIsUserAccountEnabled } from '../../store/userAccount/userAccount.selectors'
import useUIDisplay from '../ui/useUIDisplay'
import { withEverySelectorTruthy } from '../utils/react-redux'
import UserAreaAnonymous from './anonymous/UserAreaAnonymous'
import UserAreaConnected from './connected/UserAreaConnected'
import { useKeycloakEngine } from './useKeycloak'
import s from './UserArea.less'
import UserAreaPlaceHolder from './UserAreaPlaceHolder'

// webpack:BrowserOnly
const UserArea = () => {
  const { isUIDisplayed } = useUIDisplay(UI_ELEMENTS.USER)
  useKeycloakEngine()

  return (
    <>
      <Helmet>
        <body className={classNames(isUIDisplayed && 'unscrollable')} />
      </Helmet>
      <div className={classNames(s.root, isUIDisplayed && s.displayed)}>
        <UserAreaPlaceHolder />
        <UserAreaAnonymous />
        <UserAreaConnected />
      </div>
    </>
  )
}

export default withEverySelectorTruthy(selectIsUserAccountEnabled)(UserArea)
